import {
    validUrl,
    validUrlImage
} from '../../utils/url'
import axios from 'axios'

export default {
    orderChangeImage() {
        this.loaderReorga = true;
        var orderImages = this.objectImages.sort((a,b)=>{
            if (a.order < b.order)
                return -1;
            if (a.order > b.order)
                return 1;
            return 0;
        });
        axios
            .post('/products/' + this.product.id, {
                mode: 'order_image',
                orderImages
            })
            .then(r => {
                this.$store.dispatch('products/updateInList', {
                    id: this.product.id,
                    data: r.data.data
                });
            })
            .catch(e => {
                if (e.response.status == 422) {
                    this.$message.error(e.response.data.errors);
                } else {
                    this.$message.error(
                        'Erreur lors de la mise à jour.'
                    );
                }
            })
            .then(() => {
                this.loaderReorga = false;
            });
    },
    saveDefaultImage(v) {
        axios
            .post('/products/' + this.product.id, {
                mode: 'default_image',
                media_id: v
            })
            .then(r => {
                this.$store.dispatch('products/updateInList', {
                    id: this.product.id,
                    data: r.data.data
                });
            })
            .catch(e => {
                if (e.response.status == 422) {
                    this.$message.error(e.response.data.errors);
                } else {
                    this.$message.error(
                        'Erreur lors de la mise à jour.'
                    );
                }
            })
            .then(() => {});
    },
    remoteMethodTags(query) {
        if (query !== '') {
            this.loaderTags = true;
            var params = {
                q: query
            }
            axios.get('medias/tags', {
                params
            }).then((r) => {
                this.tags = r.data.data
            }).catch(() => {

            }).then(() => {
                this.loaderTags = false
            })
        } else {
            this.tags = [];
        }
    },
    handleChangeFileUrl(value) {
        this.url_upload_end = false
        this.url_upload_error = null

        if (value.indexOf('http://') == -1 && value.indexOf('https://') == -1) {
            value = 'http://' + value;
        }

        if (validUrl(value)) {
            if (validUrlImage(value)) {
                this.url_uploader = true
                axios.post('/medias', {
                    product_id: this.product.id,
                    variation_id: (this.variation.id) ? this.variation.id : '',
                    file_url: value
                }).then((response) => {
                    this.url_upload_success = true
                    this.currentObject.images.push(response.data.data);
                    this.file_url = null;
                }).catch((r) => {
                    this.url_upload_success = false
                    this.url_upload_error = r.response.data.message
                }).then(() => {
                    this.url_upload_end = true
                    this.url_uploader = false
                })
            } else {
                this.url_upload_error = 'Extension URL invalide'
            }
        } else {
            this.url_upload_error = 'URL invalide'
        }
    },
    checkFileUpload(file) {
        createImageBitmap(file).then((image) => {
            if (image.width < 400 || image.height < 400) {
                this.$message({
                    showClose: true,
                    message: "Attention : L'image est de trop faible qualité, le rendu final sera moins bon ",
                    type: 'error',
                    duration: 5000
                });
            }
        });

        var maxSizeMo = 8;
        var maxSizeBit = maxSizeMo * 1048576;
        if (file.size > maxSizeBit) {
            this.$message({
                showClose: true,
                message: "Poids de l'image trop grande, pas plus de 8Mo ",
                type: 'error',
                duration: 5000
            });
            return false;
        }
        return true;
    },
    disociateImage(image) {
        image.loader = true;
        axios
            .post(this.disociateImageUrl, {
                mode: 'disociateMedia',
                medias: [image.id]
            })
            .then(() => {
                var finded = this.currentObject.images.findIndex(
                    v => v.id == image.id
                );
                if (finded != -1) {
                    this.currentObject.images.splice(finded, 1);
                }
                this.params.page = 1;
                this.fetch()
                    .then(r => {
                        this.images = r.data.data;
                        this.pagination = r.data.meta;
                        this.tags = r.data.includes.tags;
                    })
                    .catch(() => {})
                    .then(() => {});
            })
            .catch(() => {})
            .then(() => {
                image.loader = false;
            });
    },
    removeMany() {
        this.$confirm(
                "Voulez-vous vraiment supprimer les image ?",
                'Attention', {
                    confirmButtonText: 'Oui',
                    cancelButtonText: 'Annuler',
                    type: 'warning'
                }
            )
            .then(() => {
                axios
                    .post('/medias/destroyMany', {
                        medias: this.selected,
                    })
                    .then(() => {
                        this.refreshAfterRemove(this.selected.length)
                        this.selected = []

                    })
            }).catch(() => {

            })
    },
    refreshAfterRemove(removedCount) {
        this.autoPrevPage(removedCount)
        this.fetch().then((r) => {
            this.images = r.data.data;
            this.pagination = r.data.meta;
            if( r.data &&  r.data.includes ) {
                this.tags = r.data.includes.tags;
            }
        })
    },
    //si on supprime tout les élément de la derniére page ça évite de refresh sur une page vide et ça passe à la précédente
    autoPrevPage(removedCount) {
        var nbRow = (this.pagination.to - this.pagination.from) + 1
        if (this.pagination.to == this.pagination.total && removedCount == nbRow && this.pagination.current_page > 1) {
            this.params.page = this.pagination.current_page - 1
        }
    },
    removeImage(image, noProduct) {
        this.$confirm(
                "Voulez-vous vraiment supprimer l'image ?",
                'Attention', {
                    confirmButtonText: 'Oui',
                    cancelButtonText: 'Annuler',
                    type: 'warning'
                }
            )
            .then(() => {
                image.loader = true;
                var params = {
                    product_id: this.product.id
                };
                if (noProduct) {
                    params = {};
                }
                axios
                    .delete('/medias/' + image.id, params)
                    .then(() => {
                        if (noProduct) {
                            var finded = this.images.findIndex(
                                v => v.id == image.id
                            );
                            if (finded != -1) {
                                this.images.splice(finded, 1);
                            }
                        } else {
                            var finded = this.currentObject.images.findIndex(
                                v => v.id == image.id
                            );
                            if (finded != -1) {
                                this.currentObject.images.splice(finded, 1);
                            }
                        }
                        this.refreshAfterRemove(1)
                    })
                    .catch(() => {})
                    .then(() => {
                        image.loader = false;
                    });
            })
            .catch(() => {});
    },
    uploadSuccess(response, file, fileList) {
        this.currentObject.images.push(response.data);

        if( !this.currentObject.media_id ) {
            this.currentObject.media = response.data
            this.currentObject.media_id = response.data.id
        }

        if (!this.hasVariation) {
            this.$store.dispatch('products/updateInList', {
                id: this.product.id,
                data: this.currentObject
            });
        }

        var finish = fileList.filter(v => v.status == 'success');
        if (finish.length == fileList.length) {
            setTimeout(() => {
                this.$refs.uploadProductImage.clearFiles();
            }, 300);
        }
    },
    fetch() {
        return axios.get('/medias', {
            params: this.params
        });
    },
    tagIndex(tag) {
        return this.params.tags.findIndex(v => v == tag.id);
    },
    selecTags(tag) {
        var index = this.tagIndex(tag);

        if (index != -1) {
            this.params.tags.splice(index, 1);
        } else {
            this.params.tags.push(tag.id);
        }
        this.filter();
    },
    refresh() {
        if (!this.init) return;
        this.params.page = 1;
        this.params.tags = [];
        this.tabActive = 'list';

        this.loader = true;
        this.fetch()
            .then(r => {
                this.images = r.data.data;
                this.pagination = r.data.meta;
                this.tags = r.data.includes.tags;
            })
            .catch(() => {})
            .then(() => {
                this.loader = false;
            });
    },
    filter() {
        this.$nextTick(function () {
            this.$refs.tagSelector.blur();
        });
        this.params.page = 1;

        this.loader = true;
        this.fetch()
            .then(r => {
                this.images = r.data.data;
                this.pagination = r.data.meta;
            })
            .catch(() => {})
            .then(() => {
                this.loader = false;
            });
    },
    order() {
        this.loader = true;
        this.fetch()
            .then(r => {
                this.images = r.data.data;
                this.pagination = r.data.meta;
                this.tags = r.data.includes.tags;
            })
            .catch(() => {})
            .then(() => {
                this.loader = false;
            });
    },
    paginate(page, paginator) {
        this.selected = []
        this.params.page = page;
        this.loader = true;
        this.fetch()
            .then(r => {
                this.images = r.data.data;
                this.pagination = r.data.meta;
                this.tags = r.data.includes.tags;
                if (paginator == 'bottom') {
                    var element = document.querySelector(
                        '.galery-selector .page-header'
                    );
                    element.scrollIntoView();
                }
            })
            .catch(() => {})
            .then(() => {
                this.loader = false;
            });
    },
    openLightbox(image) {
        this.lightbox.loader = true;
        this.lightbox.image = {};
        this.$nextTick(function () {
            this.lightbox.image = image;
            this.lightbox.display = true;
        });
    },
    cleanLigtbox() {
        this.lightbox = {
            display: false,
            image: {},
            loader: true
        };
    },
    select(image) {
        if (!this.selectable) return;
        var index = this.selected.findIndex(v => v == image.id);
        if (index != -1) {
            this.selected.splice(index, 1);
        } else {
            this.selected.push(image.id);
        }
    },
    isSelected(image) {
        return this.selected.findIndex(v => v == image.id) != -1;
    },
    removeSelected(selected) {
        this.selected.forEach(v => {
            var index = this.images.findIndex(r => r.id == v);
            if (index != -1) {
                this.images.splice(index, 1);
            }
        });
    },
    save() {
        this.loader = true;
        axios
            .post(this.associateImageUrl, {
                medias: this.selected,
                mode: 'gallery'
            })
            .then(r => {
                //this.updateProductInList(r.data.data.id, r.data.data);
                this.refreshAfterRemove(this.selected.length)
                this.selected = [];
                this.$emit('associated', {
                    product: this.hasVariation ? this.product : r.data.data,
                    variation: this.variation ? r.data.data : this.variation
                });
                this.tabActive = 'list';
            })
            .catch(() => {})
            .then(() => {
                this.loader = false;
            });
    },
    rotate(image, degrees) {
        image.loader = true;
        axios
            .post('/medias/' + image.id, {
                mode: 'rotate',
                degrees: degrees
            })
            .then(() => {
                this.version++;
            })
            .catch(() => {})
            .finally(() => {
                image.loader = false;
            });
    }
}
